/* eslint-disable no-irregular-whitespace */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { abrirModalLogin, fecharModalAnonimo } from '../../app/slices/modalSlice';
import {
  ContainerJanela, Divisor, Linha,
} from '../../styles/base';
import Botao from '../Botao/Botao';
import {
  Aviso,
  JanelaAnonimo, LinkParaLogar, MensagemDestaque, MensagemModal, TituloModal,
} from './ModalAnonimoEstilo';

const ModalAnonimo = ({ ouvidoria, totem, zeladoria }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const redirecionarLogin = () => {
    dispatch(fecharModalAnonimo());

    if (totem) {
      if (ouvidoria) {
        history.push('/totem/ouvidoria/cadastrar/login');
      } else if (zeladoria) {
        history.push('/totem/zeladoria/cadastrar/login');
      } else {
        history.push('/totem/sic/cadastrar/login');
      }
    } else {
      dispatch(abrirModalLogin());
    }
  };

  const redirecionarCadastro = () => {
    dispatch(fecharModalAnonimo());

    if (totem) {
      if (ouvidoria) {
        history.push('/totem/ouvidoria/conta');
      } else if (zeladoria) {
        history.push('/totem/zeladoria/conta');
      } else {
        history.push('/totem/sic/conta');
      }
    } else {
      history.push('/conta');
    }
  };

  return (
    <ContainerJanela>
      <JanelaAnonimo>
        <Linha style={{ justifyContent: 'flex-end' }}>
          <Botao
            fechar
            onClick={() => dispatch(fecharModalAnonimo())}
          />
        </Linha>

        <TituloModal>
          Acesso Anônimo
          {' '}
        </TituloModal>

        <Divisor />

        <Aviso>Aviso:</Aviso>

        {ouvidoria && (
          <MensagemModal>
            As manifestações registradas de forma
            {' '}
            <b>anônima</b>
            {' '}
            são consideradas &quot;Comunicações&quot; e
            {' '}
            <MensagemDestaque>não é possível o seu acompanhamento.</MensagemDestaque>

            <Divisor />

            Caso deseje acompanhar o andamento da sua manifestação e receber uma resposta do órgão ou entidade, por favor
            {' '}
            <LinkParaLogar onClick={() => redirecionarLogin()}>identifique-se.</LinkParaLogar>
          </MensagemModal>
        )}

        {!ouvidoria && !zeladoria && (
          <MensagemModal>
            Os pedidos de informação registrados de forma
            {' '}
            <b>anônima</b>
            {' '}
            são considerados &quot;Comunicações&quot; e
            {' '}
            <MensagemDestaque>não é possível o seu acompanhamento.</MensagemDestaque>

            <Divisor />

            Caso deseje acompanhar o retorno da sua solicitação e receber uma resposta do órgão ou entidade, por favor
            {' '}
            <LinkParaLogar onClick={() => redirecionarLogin()}>identifique-se.</LinkParaLogar>
          </MensagemModal>
        )}

        {zeladoria && (
          <MensagemModal>
            As zeladorias registradas de forma
            {' '}
            <b>anônima</b>
            {' '}
            são consideradas &quot;Comunicações&quot; e
            {' '}
            <MensagemDestaque>não é possível o seu acompanhamento.</MensagemDestaque>

            <Divisor />

            Caso deseje acompanhar a sua solicitação, por favor
            {' '}
            <LinkParaLogar onClick={() => redirecionarLogin()}>identifique-se.</LinkParaLogar>
          </MensagemModal>
        )}

        <Divisor size="medio" />

        <Botao
          label="Não tem cadastro? Cadastre-se"
          router
          onClick={() => redirecionarCadastro()}
        />

        <Divisor />

        <Botao
          label="Continuar como anônimo"
          link
          onClick={() => dispatch(fecharModalAnonimo())}
        />
      </JanelaAnonimo>
    </ContainerJanela>
  );
};

ModalAnonimo.propTypes = {
  ouvidoria: PropTypes.bool,
  totem: PropTypes.bool,
  zeladoria: PropTypes.bool,
};

ModalAnonimo.defaultProps = {
  ouvidoria: true,
  totem: false,
  zeladoria: false,
};

export default ModalAnonimo;
